import React from 'react';
import {Link, List, ListItem, Typography} from "@mui/material";
import {config} from "../../config";

export const ExampleCode = () => {
    return (<React.Fragment>
        <Typography variant="h5" component={'h2'} align="left">
            {config().exampleCode.title}
        </Typography>
        <List dense={false} className={'personal-projects'}>
            {
                config().exampleCode.codeLinks.map((project, index) => (
                    <ListItem key={index}>
                        <Link href={project.url}>
                            {project.label}
                        </Link>
                    </ListItem>
                ))
            }
        </List>
    </React.Fragment>);
}